import { useMutation } from '@tanstack/react-query';

import type { TStaffTransitionPayload, TStaffTransitionReport } from '@/services/staff';

import { notifyMeta } from '@/lib/notify';
import { errorUtils } from '@/services/errors';
import { staffService } from '@/services/staff';

const previewStaffTransition = async (payload: TStaffTransitionPayload) => errorUtils.unwrap(await staffService.transitionStaff(payload));

const usePreviewStaffTransition = () => useMutation<TStaffTransitionReport, Error, TStaffTransitionPayload>({
  meta: notifyMeta('staffTransitionPreview'),
  mutationKey: ['staff', 'transition-preview'],
  mutationFn: previewStaffTransition,
});

export {
  usePreviewStaffTransition,
};
